export const isWinter = (): boolean => {
  const month = new Date().getMonth();
  return month === 0 || month === 11;
};

export const isEaster = (): boolean => {
  const now = new Date();
  if (now.getFullYear() === 2021) {
    if (now.getMonth() === 2) {
      return now.getDate() >= 21;
    }
    if (now.getMonth() === 3) {
      return now.getDate() <= 7;
    }
  }
  return false;
};
